<template>
  <a class="rs-listing__card rs-video-listing__card" :href="post.permalink">
    <div class="rs-listing__card__image rs-video-listing__card__image">
      <div v-if="post.featured_image">
        <svg
          class="rs-video-listing__card__image__playicon"
          width="60"
          height="60"
          viewBox="0 0 68 47.812"
        >
          <g transform="translate(-6724 -9005)">
            <path
              id="outer"
              d="M81.512,71.481A8.544,8.544,0,0,0,75.5,65.43C70.2,64,48.933,64,48.933,64s-21.264,0-26.567,1.43a8.544,8.544,0,0,0-6.012,6.051c-1.421,5.337-1.421,16.473-1.421,16.473s0,11.136,1.421,16.474a8.417,8.417,0,0,0,6.012,5.954c5.3,1.43,26.567,1.43,26.567,1.43s21.264,0,26.567-1.43a8.417,8.417,0,0,0,6.012-5.954c1.421-5.337,1.421-16.474,1.421-16.474S82.933,76.818,81.512,71.481ZM41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="red"
            />
            <path
              id="inner"
              d="M41.978,98.065V77.844L59.751,87.955,41.978,98.065Z"
              transform="translate(6709.067 8941)"
              fill="#fff"
            />
          </g>
        </svg>
        <div v-html="post.featured_image"></div>
      </div>
    </div>

    <div class="rs-video-listing__card__meta">
      <div class="rs-video-listing__card__meta__categories">
        Animations
      </div>
      <div class="rs-video-listing__card__meta__title">
        <h2 v-html="post.post_title"></h2>
      </div>
      <div
        class="rs-video-listing__card__meta__subtitle"
        v-html="post.page_subtitle"
      ></div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    baseURL: String,
    post: Object,
  },
};
</script>
